import React from "react";
import ActionButton from "../../../../ActionButton";
import { Button, Tooltip as MTooltip } from "@material-ui/core";
import icon_see_file from "../../../AllTransactions/assets/svg/icon_see_file.png";
import { TextButtonActions } from "../../../AllTransactions/components/styles/AllTransactionTable.style";
import CustomPopover from "../../../../CustomPopover";

const TransactionSegmentsActionColumn = ({
  permissions,
  rowData,
  handleVerify,
}) => {
  const haveFilesPermission =
    permissions && permissions?.files_transactions_segment;

  return (
    <CustomPopover text="Add Items" icon={<ActionButton></ActionButton>}>
      {!!haveFilesPermission && (
        <div className="row px-2">
          <MTooltip title="See files">
            <Button
              style={{ marginLeft: 0, marginRight: 0, marginBottom: -3 }}
              color="primary"
              className="justify-content-start w-100"
              startIcon={
                <img
                  src={icon_see_file}
                  style={{ width: "24px", height: "24px" }}
                  alt="See files icon"
                />
              }
              onClick={() => {
                const { _id, practiceId: p } = rowData;
                handleVerify(_id, p);
              }}
            >
              <TextButtonActions>See File</TextButtonActions>
            </Button>
          </MTooltip>
        </div>
      )}
    </CustomPopover>
  );
};

export default TransactionSegmentsActionColumn;
